<template>
  <section class="container member-layout" :class="{ 'member-layout-wallet': hasRightRail }">
    <aside class="member-sidebar" aria-label="会员中心导航">
      <div class="member-sidebar-profile">
        <button class="member-sidebar-avatar" aria-label="查看个人资料" @click="navigate('/member')">
          <img v-if="memberAvatarUrl" :src="memberAvatarUrl" alt="个人头像" />
          <span v-else>{{ userName?.slice(0, 1).toUpperCase() || 'M' }}</span>
        </button>
        <b class="member-sidebar-name"><span class="member-sidebar-account" :title="isLoggedIn ? userName : undefined">{{ isLoggedIn ? userName : '欢迎来到万博体育' }}</span><small v-if="isLoggedIn" class="member-vip-badge"><SiteIcon name="diamond" :size="12" />{{ memberDashboard?.levelName || '会员' }}</small></b>
        <span v-if="isLoggedIn && memberDashboard?.joinedDays != null">加入万博体育第{{ memberDashboard.joinedDays }}天</span><span v-else-if="isLoggedIn">会员中心</span><button v-else type="button" class="member-login" @click="openAuth('login')">登录后管理您的账户<span aria-hidden="true"> ›</span></button>
      </div>
      <div class="member-sidebar-finance">
        <button v-for="item in financeLinks" :key="item.path" :class="{ active: currentPath === item.path }" @click="navigate(item.path)">
          <ReferenceImage :image="item.image" /><span>{{ item.label }}</span>
        </button>
      </div>
      <nav>
        <template v-for="item in visibleMemberNavigation" :key="item.path">
          <button :class="{active:isActive(item.path),'member-nav-group-start':['/mine/finance/wallet','/mine/record/giftRecord'].includes(item.path)}" :aria-current="isActive(item.path) ? 'page' : undefined" @click="navigate(item.path)">
            <ReferenceImage class="member-nav-symbol" :image="memberArtwork[item.path]?.[isActive(item.path) ? 1 : 0]" />{{ item.label }}<span class="member-nav-chevron" aria-hidden="true">›</span>
          </button>
          <button v-if="item.path === '/mine/record/welfare' && isLoggedIn && invitationActivity" type="button" aria-haspopup="dialog" @click="openInvitation()">
            <SiteIcon class="member-nav-symbol" name="gift" :size="20" />邀请好友<span class="member-nav-chevron" aria-hidden="true">›</span>
          </button>
        </template>
      </nav>
    </aside>
    <div class="member-content"><slot /></div>
    <FinanceRecordRail v-if="hasRightRail && isFinance" /><MemberRightRail v-else-if="hasRightRail" />
  </section>
</template>
<script setup>
import SiteIcon from '../SiteIcon.vue'
import ReferenceImage from '../ReferenceImage.vue'
import { memberArtwork } from '../../config/referencePresentation.js'
import MemberRightRail from './MemberRightRail.vue'
import FinanceRecordRail from './FinanceRecordRail.vue'
import { computed, provide } from 'vue'
import { useBalanceTreasureAvailability, balanceTreasureAvailabilityKey } from '../../composables/useBalanceTreasureAvailability.js'
import { memberNavigation } from '../../config/navigation.js'
import { useAppContext } from '../../composables/appContext'
const { asset, currentPath, isLoggedIn, memberAvatarUrl, memberDashboard, openAuth, navigate, userName, invitationActivity, openInvitation } = useAppContext()
const treasureAvailability = useBalanceTreasureAvailability({ isLoggedIn, userName, currentPath })
provide(balanceTreasureAvailabilityKey, treasureAvailability)
const visibleMemberNavigation = computed(() => memberNavigation.filter(item => item.path !== '/member/balance-treasure' || treasureAvailability.available.value === true))
const isActive = path=>path===currentPath.value || path==='/mine/vip' && (['/member/vip','/member/gift'].includes(currentPath.value) || currentPath.value.startsWith('/mine/vip/'))
const isFinance = computed(()=>/^\/mine\/finance\/(deposit|transfer|withdrawal)$/.test(currentPath.value))
const hasRightRail = computed(()=>['/member','/mine/finance/wallet'].includes(currentPath.value) || isFinance.value)
const financeLinks = [
  { label: '存款', path: '/mine/finance/deposit', image:17 },
  { label: '转账', path: '/mine/finance/transfer', image:19 },
  { label: '取款', path: '/mine/finance/withdrawal', image:21 },
]
const icons = { account: 'identification-card', vip: 'seal-check', gift: 'gift', wallet: 'money', rebate: 'arrow-circle-down', record: 'receipt', message: 'chats', help: 'question' }
</script>

<style scoped>
.member-sidebar-profile { min-width:0; padding:28px 18px 4px; }
.member-sidebar-avatar { width:72px; height:72px; margin-bottom:14px; box-shadow:0 0 0 5px #f3f8fc; }
.member-sidebar-name { flex-direction:column; width:100%; min-width:0; gap:8px; color:#515d76; font-size:14px; font-weight:500; }
.member-sidebar-account { display:block; max-width:100%; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.member-sidebar-name .member-vip-badge { flex:none; max-width:100%; gap:4px; min-height:20px; padding:2px 8px; font-size:11px; line-height:16px; }
.member-sidebar-profile > span { margin-top:8px; color:#9ba4b5; font-size:11px; }
.member-login { min-height:44px; padding:8px; border:0; background:transparent; color:var(--kg-brand,#179cff); font:inherit; font-size:12px; cursor:pointer; }
.member-login:focus-visible { outline:2px solid var(--kg-brand,#179cff); outline-offset:2px; }
</style>
